<div class="w-full mx-auto p-5 space-y-5">

  <!-- ============================================================ -->
  <!-- Header                                                       -->
  <!-- ============================================================ -->
  <div class="flex flex-wrap justify-between items-end gap-4">
    <div>
      <div class="flex items-center gap-2 text-xs font-medium text-slate-500 uppercase tracking-wider">
        <span>Tesorería</span>
        <span class="text-slate-300">/</span>
        <span class="text-slate-700">Devoluciones</span>
      </div>
      <h1 class="text-2xl font-semibold text-slate-900 mt-1">Devoluciones</h1>
      <p class="text-sm text-slate-500 mt-1 tabular-nums">
        {{ filteredVouchers.length }} devoluciones · Registro y seguimiento de devoluciones financieras
      </p>
    </div>
    <a routerLink="/refund-vouchers/new" class="btn btn-primary">
      <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2.2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 4v16m8-8H4" />
      </svg>
      Nueva Devolución
    </a>
  </div>

  <!-- ============================================================ -->
  <!-- KPIs                                                         -->
  <!-- ============================================================ -->
  <div class="grid grid-cols-1 sm:grid-cols-3 gap-3">

    <div class="kpi-card kpi-sky">
      <div class="kpi-label">
        <span class="kpi-icon">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M19 14l-7 7m0 0l-7-7m7 7V3" />
          </svg>
        </span>
        Total Devoluciones
      </div>
      <div class="kpi-value">{{ totalRefundAmount | currency:'COP':'symbol':'1.0-0' }}</div>
      <div class="kpi-hint">Suma global emitida</div>
    </div>

    <div class="kpi-card kpi-emerald">
      <div class="kpi-label">
        <span class="kpi-icon">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
          </svg>
        </span>
        Monto Procesado
      </div>
      <div class="kpi-value">{{ totalProcessedAmount | currency }}</div>
      <div class="kpi-hint">Liquidado a beneficiarios</div>
    </div>

    <div class="kpi-card kpi-amber">
      <div class="kpi-label">
        <span class="kpi-icon">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
        </span>
        Monto Pendiente
      </div>
      <div class="kpi-value">{{ totalPendingAmount | currency }}</div>
      <div class="kpi-hint">En proceso de pago</div>
    </div>
  </div>

  <!-- ============================================================ -->
  <!-- Toolbar de filtros                                           -->
  <!-- ============================================================ -->
  <div class="filters-toolbar">
    <div class="grid grid-cols-12 gap-3">

      <!-- Buscar -->
      <div class="col-span-12 md:col-span-4">
        <div class="relative">
          <svg class="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
          <input type="text" [(ngModel)]="searchTerm" (input)="applyFilters()"
            placeholder="Buscar por documento, participante o proyecto..."
            class="w-full pl-9 pr-3 h-[38px] border border-slate-200 rounded-lg text-sm bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent placeholder-slate-400">
        </div>
      </div>

      <!-- Estado -->
      <div class="col-span-6 md:col-span-2">
        <select [(ngModel)]="selectedStatus" (change)="applyFilters()"
          class="w-full h-[38px] px-3 border border-slate-200 rounded-lg text-sm bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent text-slate-700">
          <option value="">Estado</option>
          <option *ngFor="let status of refundStatuses" [value]="status.value">{{ status.label }}</option>
        </select>
      </div>

      <!-- Tipo -->
      <div class="col-span-6 md:col-span-2">
        <select [(ngModel)]="selectedRefundType" (change)="applyFilters()"
          class="w-full h-[38px] px-3 border border-slate-200 rounded-lg text-sm bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent text-slate-700">
          <option value="">Tipo</option>
          <option *ngFor="let type of refundTypes" [value]="type.value">{{ type.label }}</option>
        </select>
      </div>

      <!-- Banco -->
      <div class="col-span-6 md:col-span-2">
        <select [(ngModel)]="selectedBank" (change)="applyFilters()"
          class="w-full h-[38px] px-3 border border-slate-200 rounded-lg text-sm bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent text-slate-700">
          <option value="">Banco</option>
          <option *ngFor="let bank of banks" [value]="bank.value">{{ bank.label }}</option>
        </select>
      </div>

      <!-- Proyecto -->
      <div class="col-span-6 md:col-span-2">
        <select [(ngModel)]="selectedProject" (change)="applyFilters()"
          class="w-full h-[38px] px-3 border border-slate-200 rounded-lg text-sm bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent text-slate-700">
          <option value="">Proyecto</option>
          <option *ngFor="let project of projects" [value]="project.value">{{ project.label }}</option>
        </select>
      </div>

      <!-- Fila 2: fechas -->
      <div class="col-span-12 md:col-span-4">
        <select [(ngModel)]="dateType" (change)="onDateFilterChange()"
          class="w-full h-[38px] px-3 border border-slate-200 rounded-lg text-sm bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent text-slate-700">
          <option *ngFor="let dt of dateTypes" [ngValue]="dt.value">{{ dt.label }}</option>
        </select>
      </div>

      <div class="col-span-6 md:col-span-3">
        <input type="date" [(ngModel)]="fromDate" (change)="onDateFilterChange()"
          class="w-full h-[38px] px-3 border border-slate-200 rounded-lg text-sm bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent text-slate-700 tabular-nums">
      </div>

      <div class="col-span-6 md:col-span-3">
        <input type="date" [(ngModel)]="toDate" (change)="onDateFilterChange()"
          class="w-full h-[38px] px-3 border border-slate-200 rounded-lg text-sm bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent text-slate-700 tabular-nums">
      </div>

      <div class="col-span-12 md:col-span-2 flex justify-end">
        <button (click)="resetFilters()" class="btn btn-ghost btn-sm">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
          Limpiar
        </button>
      </div>
    </div>
  </div>

  <!-- ============================================================ -->
  <!-- Listado                                                      -->
  <!-- ============================================================ -->
  <div class="space-y-3">

    <!-- Empty state -->
    <div *ngIf="filteredVouchers.length === 0"
      class="bg-white border border-dashed border-slate-300 rounded-xl p-10 text-center">
      <div class="mx-auto w-12 h-12 rounded-full bg-slate-100 flex items-center justify-center mb-3">
        <svg class="w-6 h-6 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M9 8l-3 3m0 0l3 3m-3-3h12a3 3 0 013 3v3" />
        </svg>
      </div>
      <p class="text-sm font-medium text-slate-700">No se encontraron devoluciones</p>
      <p class="text-xs text-slate-500 mt-1">Ajustá los filtros o crea una nueva devolución.</p>
    </div>

    <div *ngFor="let voucher of filteredVouchers" class="receipt-row"
      [class.stripe-emerald]="voucher.status === 'Completed'"
      [class.stripe-amber]="voucher.status === 'Processing' || voucher.status === 'Pending'"
      [class.stripe-rose]="voucher.status === 'Rejected' || voucher.status === 'Cancelled'"
      [class.stripe-slate]="!voucher.status">

      <div class="status-stripe"></div>

      <div class="p-4 space-y-3">

        <!-- Fila principal -->
        <div class="flex items-start justify-between gap-4">

          <div class="min-w-0 flex-1">
            <div class="flex items-center flex-wrap gap-2">
              <a [routerLink]="['/refund-vouchers/view', voucher.id]" target="_blank"
                class="inline-flex items-center gap-1.5 text-base font-semibold text-slate-900 hover:text-blue-700 transition-colors group">
                <span class="tabular-nums">{{ voucher.documentNumber }}</span>
                <svg class="w-3.5 h-3.5 text-slate-400 opacity-0 group-hover:opacity-100 transition-opacity"
                  fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                </svg>
              </a>

              <span class="pill"
                [ngClass]="{
                  'pill-emerald': voucher.status === 'Completed',
                  'pill-amber':   voucher.status === 'Processing' || voucher.status === 'Pending',
                  'pill-rose':    voucher.status === 'Rejected' || voucher.status === 'Cancelled',
                  'pill-neutral': !voucher.status
                }">
                {{ voucher.statusDescription }}
              </span>
            </div>

            <!-- Participante + proyecto -->
            <div class="mt-2 flex flex-wrap items-baseline gap-x-3 gap-y-1">
              <span class="text-sm font-medium text-slate-800 flex items-center gap-1.5">
                <svg class="w-3.5 h-3.5 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
                {{ voucher.participant?.firstName }} {{ voucher.participant?.lastName }}
              </span>
              <span class="text-xs text-slate-400">{{ voucher.refundTypeDescription }}</span>
            </div>
            <p class="mt-0.5 text-xs text-slate-500 truncate">
              {{ voucher.project.projectName }} · {{ voucher.bank?.bankName }}
            </p>
          </div>

          <!-- Monto -->
          <div class="flex-shrink-0 text-right">
            <p class="text-[11px] font-medium text-slate-400 uppercase tracking-wide">Total</p>
            <p class="text-xl font-semibold text-slate-900 tabular-nums leading-tight">
              {{ formatCurrencyWithCode(voucher.refundAmount, voucher) }}
            </p>
            <p class="text-[11px] text-slate-400 tabular-nums mt-0.5">
              {{ voucher.documentDate | date:'dd/MM/yy' }}
            </p>
          </div>
        </div>

        <!-- Grid de metadatos -->
        <div class="grid grid-cols-2 md:grid-cols-3 gap-x-4 gap-y-3 pt-3 border-t border-slate-100">

          <div class="data-cell">
            <span class="data-label">Procesado</span>
            <span class="data-value text-emerald-700 tabular-nums">
              {{ formatCurrencyWithCode(voucher.processedAmount || 0, voucher) }}
            </span>
          </div>

          <div class="data-cell">
            <span class="data-label">Pendiente</span>
            <span class="data-value tabular-nums" [ngClass]="(voucher.pendingAmount || 0) > 0 ? 'text-amber-700' : 'text-slate-500'">
              {{ formatCurrencyWithCode(voucher.pendingAmount || 0, voucher) }}
            </span>
          </div>

          <div class="data-cell" *ngIf="voucher.status === 'Processing' || voucher.status === 'Completed'">
            <span class="data-label">Avance</span>
            <div class="flex items-center gap-2">
              <div class="flex-1 bg-slate-100 rounded-full h-1.5">
                <div class="bg-emerald-500 h-1.5 rounded-full transition-all" [style.width.%]="getProcessingProgress(voucher)"></div>
              </div>
              <span class="text-xs text-slate-600 tabular-nums">{{ getProcessingProgress(voucher) | number:'1.0-0' }}%</span>
            </div>
          </div>
        </div>

        <!-- Auditoría -->
        <app-audit-info [auditData]="{
            createdBy: voucher.createdBy,
            createdAt: voucher.createdAt,
            updatedBy: voucher.updatedBy,
            updatedAt: voucher.updatedAt,
            deletedBy: voucher.deletedBy,
            deletedAt: voucher.deletedAt,
            isDeleted: voucher.isDeleted
          }" layout="compact" size="sm">
        </app-audit-info>

        <!-- Acciones -->
        <div class="flex flex-wrap items-center justify-end gap-1 pt-2 border-t border-slate-100">
          <a [routerLink]="['/refund-vouchers/view', voucher.id]" class="row-action row-action--primary" title="Ver detalle">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.8">
              <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
            </svg>
            <span>Detalles</span>
          </a>
        </div>
      </div>
    </div>
  </div>

</div>
